import { decimalToSexagesimal, sexagesimalToDecimal, getDistance, } from 'geolib';
import { useEffect, useRef } from 'react';
import proj4 from 'proj4';
var useMapTranslation = function (leftUpperCorner, rightLowerCorner) {
    var startEdgeRef = useRef({
        x: 0,
        y: 0,
    });
    var endEdgeRef = useRef({
        x: 0,
        y: 0,
    });
    var scalingFactorRef = useRef({
        x: 1,
        y: 1,
    });
    var destStr = 'EPSG:3857';
    var srcStr = 'EPSG:4326';
    useEffect(function () {
        if (!leftUpperCorner ||
            leftUpperCorner.length === 0 ||
            !rightLowerCorner ||
            rightLowerCorner.length === 0) {
            return;
        }
        var tlDecimal = leftUpperCorner.map(function (x) { return sexagesimalToDecimal(x); });
        var brDecimal = rightLowerCorner.map(sexagesimalToDecimal);
        var _a = proj4(srcStr, destStr, tlDecimal), tl_long = _a[0], tl_lat = _a[1];
        var _b = proj4(srcStr, destStr, brDecimal), br_long = _b[0], br_lat = _b[1];
        startEdgeRef.current = {
            x: tl_long,
            y: tl_lat,
        };
        endEdgeRef.current = {
            x: br_long,
            y: br_lat,
        };
        scalingFactorRef.current = {
            x: Math.abs(endEdgeRef.current.x - startEdgeRef.current.x) / 1200,
            y: Math.abs(endEdgeRef.current.y - startEdgeRef.current.y) / 1100,
        };
        window.geolib = {
            getDistance: getDistance,
            decimalToSexagesimal: decimalToSexagesimal,
            sexagesimalToDecimal: sexagesimalToDecimal,
            proj4: proj4,
        };
    }, [leftUpperCorner, rightLowerCorner]);
    return {
        xyToLatLang: function (x, y, mapElement) {
            var startEdge = startEdgeRef.current;
            var scalingFactor = scalingFactorRef.current;
            var localX = x * scalingFactor.x;
            var localY = y * scalingFactor.y;
            var x3857 = startEdge.x + localX;
            var y3857 = startEdge.y - localY;
            var destCord = proj4(destStr, srcStr, [x3857, y3857]);
            var long = destCord[0], lat = destCord[1];
            if (!lat || !long) {
                return ['', '', '', ''];
            }
            return [
                "" + decimalToSexagesimal(lat),
                " " + (lat > 0 ? 'N' : 'S'),
                "" + decimalToSexagesimal(long),
                "" + (long > 0 ? 'E' : 'W'),
            ];
        },
        latLangToXY: function (longitude, latitude, mapElement) {
            var startEdge = startEdgeRef.current;
            var scalingFactor = scalingFactorRef.current;
            var longitudeDecimal = sexagesimalToDecimal(longitude);
            var latitudeDecimal = sexagesimalToDecimal(latitude);
            var _a = proj4(srcStr, destStr, [
                longitudeDecimal,
                latitudeDecimal,
            ]), x3857 = _a[0], y3857 = _a[1];
            var localX = x3857 - startEdge.x;
            var localY = startEdge.y - y3857;
            var pixelX = localX / scalingFactor.x;
            var pixelY = localY / scalingFactor.y;
            return [pixelX, pixelY];
        },
    };
};
export default useMapTranslation;
//# sourceMappingURL=useMapTranslation.js.map